export default "__VITE_ASSET__YPA2QZrl__"